import { Component, OnInit, Input } from '@angular/core';
import { DataService } from '../../services/data.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { AssemblyCosts, Budget, GeneratedBy } from '../interfaces/index';
import { BudgetModel } from '../models/budget-model';
import * as firebase from 'firebase';
import { AppUserUtil } from '../../interfaces/app-user';

@Component({
  selector: 'app-assemblyCosts-form',
  templateUrl: './assemblyCosts-form.component.html',
  styleUrls: ['./assemblyCosts-form.component.scss']
})
export class AssemblyCostsFormComponent implements OnInit {

  private _budget: Budget;

  @Input() set budget(b: Budget) {
    this._budget = b;
    if (this.assemblyCostsForm) {
      if (BudgetModel.isEditable(this._budget)) {
        this.assemblyCostsForm.enable();
      } else {
        this.assemblyCostsForm.disable();
      }
    }
  }

  public assemblyCostsForm: FormGroup;

  constructor(private dataService: DataService, private fb: FormBuilder) { }

  ngOnInit() {

    // Definition of the assemblyCosts Form
    // build the form model
    this.assemblyCostsForm = this.fb.group({
      employee: [this._budget.assemblyCosts ? this._budget.assemblyCosts.employee : 0, [Validators.min(0), this.isInteger]],
      projectManager: [this._budget.assemblyCosts ? this._budget.assemblyCosts.projectManager : 0, [Validators.min(0), this.isInteger]],
      employeeDays: [this._budget.assemblyCosts ? this._budget.assemblyCosts.employeeDays : 0, Validators.min(0)],
      projectManagerDays: [this._budget.assemblyCosts ? this._budget.assemblyCosts.projectManagerDays : 0, Validators.min(0)],
      employeeCost: [this._budget.assemblyCosts ? this._budget.assemblyCosts.employeeCost : 0, Validators.min(0)],
      projectMangerCost: [this._budget.assemblyCosts ? this._budget.assemblyCosts.projectMangerCost : 0, Validators.min(0)],
      travelExpensesAccomodation:
      [this._budget.assemblyCosts ? this._budget.assemblyCosts.travelExpensesAccomodation : 0, Validators.min(0)],
      travelExpensesFlights: [this._budget.assemblyCosts ? this._budget.assemblyCosts.travelExpensesFlights : 0, Validators.min(0)],
      renting: [this._budget.assemblyCosts ? this._budget.assemblyCosts.renting : 0, Validators.min(0)],
      externalManpower: [this._budget.assemblyCosts ? this._budget.assemblyCosts.externalManpower : 0, Validators.min(0)],
      other: [this._budget.assemblyCosts ? this._budget.assemblyCosts.other : 0, Validators.min(0)],
    });

    if (!BudgetModel.isEditable(this._budget)) {
      this.assemblyCostsForm.disable();
    }

  }

  isInteger = (control: FormControl) => {
    const val = control.value;
    if (Number.isInteger(val)) {
      return null;
    } else {
      return {
        isNotInteger: { value: val }
      };
    }
  }

  submit() {
    const ac = {
      employee: this.assemblyCostsForm.value.employee,
      projectManager: this.assemblyCostsForm.value.projectManager,
      employeeDays: this.assemblyCostsForm.value.employeeDays,
      projectManagerDays: this.assemblyCostsForm.value.projectManagerDays,
      employeeCost: this.assemblyCostsForm.value.employeeCost,
      projectMangerCost: this.assemblyCostsForm.value.projectMangerCost,
      travelExpensesAccomodation: this.assemblyCostsForm.value.travelExpensesAccomodation,
      travelExpensesFlights: this.assemblyCostsForm.value.travelExpensesFlights,
      renting: this.assemblyCostsForm.value.renting,
      externalManpower: this.assemblyCostsForm.value.externalManpower,
      other: this.assemblyCostsForm.value.other
    };

    let assembyTotal = ac.employee * ac.employeeDays * ac.employeeCost;
    assembyTotal += ac.projectManager * ac.projectManagerDays * ac.projectMangerCost;
    assembyTotal += ac.travelExpensesAccomodation + ac.travelExpensesFlights + ac.renting + ac.other;

    this.dataService.patchBudget(this._budget.id, {
        assemblyCosts: ac
      })
      .then(() => {
        // GENERATE NEW ACTIVITY OR UPDATE
        return this.dataService.updateSubBudget(this._budget.id, 'ASSEMBLY', {
          description: 'Installation',
          id: 'ASSEMBLY',
          overrideLock: true,
          created: firebase.firestore.FieldValue.serverTimestamp(),
          deleted: null,
          active: true,
          createdBy: undefined, // This will be filled by dataservice
          generatedBy: GeneratedBy.Assembly,
          calculate: true
        });
      })
      .then(() => {
        return this.dataService.setSBActivity(this._budget.id, 'ASSEMBLY', 'projectManager', {
          activity: 'Project Manager Installation',
          category: 'INS',
          hours: ac.projectManager * ac.projectManagerDays * 24,
          cost: ac.projectMangerCost / 24
        });
      })
      .then(() => {
        return this.dataService.setSBActivity(this._budget.id, 'ASSEMBLY', 'employee', {
          activity: 'Employee Installation',
          category: 'INS',
          hours: ac.employee * ac.employeeDays * 24,
          cost: ac.employeeCost / 24
        });
      })
      .then(() => {
        return this.dataService.setSBMaterial(this._budget.id, 'ASSEMBLY', 'travelExpenses', {
          description: 'Travel Expenses Accomodation',
          category: 'INS',
          costEach: ac.travelExpensesAccomodation,
          quantity: 1,
          unit: 'pieces'
        });
      })
      .then(() => {
        return this.dataService.setSBMaterial(this._budget.id, 'ASSEMBLY', 'flights', {
          description: 'Travel Expenses Flights',
          category: 'INS',
          costEach: ac.travelExpensesFlights,
          quantity: 1,
          unit: 'pieces'
        });
      })
      .then(() => {
        return this.dataService.setSBMaterial(this._budget.id, 'ASSEMBLY', 'externalManpower', {
          description: 'External Manpower',
          category: 'INS',
          costEach: ac.externalManpower,
          quantity: 1,
          unit: 'pieces'
        });
      })
      .then(() => {
        return this.dataService.setSBMaterial(this._budget.id, 'ASSEMBLY', 'renting', {
          description: 'Renting',
          category: 'INS',
          costEach: ac.renting,
          quantity: 1,
          unit: 'pieces'
        });
      })
      .then(() => {
        return this.dataService.setSBMaterial(this._budget.id, 'ASSEMBLY', 'other', {
          description: 'Other',
          category: 'INS',
          costEach: ac.other,
          quantity: 1,
          unit: 'pieces'
        });
      })
      .then(() => {
        console.log('All Done');
      });

    // let costSummary = this.budget.costSummary;
    // if (costSummary) {
    //   costSummary.assembly = assembyTotal;
    // } else {
    //   costSummary = {
    //     assembly: assembyTotal
    //   };
    // }

    // this.dataService.patchBudget(this.budget.id, {
    //   assemblyCosts: ac,
    //   costSummary: costSummary
    // })
    // .then((data) => {
    //   console.log('Budget patched', data);
    // });
  }

}




// WEBPACK FOOTER //
// ./src/app/budget/components/assemblyCosts-form.component.ts